/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiSwitch } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { useQueryStringParams } from '@modules/utils/qs'

import { filterSchema } from './schema'

import type { FC } from 'react'

const IncludeDeletedFilter: FC = () => {
  const {
    setQueryStringItem,
    queryStringItems: { include_deleted: includeDeleted },
  } = useQueryStringParams(filterSchema.parse)

  return (
    <EuiSwitch
      label={<FormattedMessage id='include-deleted' defaultMessage='Include deleted' />}
      onChange={(e) => {
        setQueryStringItem('include_deleted', e.target.checked ? 'true' : undefined)
      }}
      checked={includeDeleted === true}
    />
  )
}

export default IncludeDeletedFilter
